import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemTree } from '../editor-booking-item-tree/editor-booking-item-tree.model';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorBookingItemTreeDataEditStore } from '../editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-tree-booking-type]',
    templateUrl: './editor-booking-item-tree-booking-type.component.html',
    styleUrls: ['./editor-booking-item-tree-booking-type.component.css'],
    standalone: false
})
export class EditorBookingItemTreeBookingTypeComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  itemTree: EditorBookingItemTree;

  bookingTypeName: string = null;

  constructor(
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private editorData: EditorDataService,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {
    combineLatest(this.itemTreeStore.itemTree$, this.editorData.bookingTypeNames$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([itemTree, bookingTypeNames]) => {
        this.bookingTypeName = itemTree === null ? null : itemTree.getBookingTypeName(bookingTypeNames);
      });

    this.itemTreeStore.itemTree$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(itemTree => this.itemTree = itemTree);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onEdit() {
    this.itemTreeDataEditStore.startEditing({ name: 'bookingType' });
    this.itemDialogStore.editBookingItemTree();
    return false;
  }
}
